import { Popover } from '@headlessui/react';
import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './menuItem.css';

/*
#tailwind
menuItem menuItem--disabled menuItem--selected
*/

function MenuItem({
  children,
  disabled,
  selected,
  onClick,
  onMouseDown,
  onMouseUp,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  icon,
  className,
  ...other
}) {
  return (
    <Popover.Button
      as="button"
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={disabled ? '-1' : '0'}
      className={bem`menuItem--${{
        disabled,
        selected,
      }} ${className}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      {...other}
    >
      {icon}
      {children}
    </Popover.Button>
  );
}

MenuItem.propTypes = {
  icon: PropTypes.node,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

MenuItem.defaultProps = {
  icon: undefined,
  onClick: undefined,
  onMouseDown: undefined,
  onMouseUp: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  onFocus: undefined,
  onBlur: undefined,
  selected: false,
  disabled: false,
  children: undefined,
  className: undefined,
};

export default MenuItem;
